import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
export default function ContestEnterNowSection({
    userinfo
}) {
    const setting = useSelector(state => state.user.setting)
    return (
        <div className='w-[1280px] smsize:w-full m-auto flex justify-center items-center my-3'>
            <div className='w-full bg-[#202020] rounded-[33px] flex justify-between items-center smsize:justify-center py-5 px-8 text-white smsize:flex-col smsize:text-left smsize:items-start smsize:gap-4 smsize:px-5'>
                <div className='flex gap-5 items-center smsize:flex-col smsize:text-left smsize:items-start smsize:gap-1'>
                    <h4 className='text-[#DBE366] text-[35px] smsize:text-[18px] uppercase smsize:whitespace-nowrap'>{setting?.contest?.title || 'The Summer Beauty Contest'}</h4>
                    {/* <p className='text-[24px] smsize:text-[15px] smsize:text-left'>when you invite a friend to join Fitzba</p> */}
                </div>
                <Link to='/login?ref=contest'
                    className='bg-[#DBE366] rounded-full py-1 px-10 uppercase text-[#202020] text-[18px] smsize:text-[12px]'>
                    Enter Now
                </Link>
            </div>
        </div>
    )
}
